import { useQuery } from '@tanstack/react-query';
import { queryKey } from '../constant/queryKey';
import { goodsService } from 'shared/src/api/goodsService';
import { useGoodsSno } from '../hooks/useGoodsSno';

export const useRelatedGoods = (enabled: boolean) => {
  const goodsSno = useGoodsSno();

  return useQuery({
    queryKey: queryKey.relatedGoods(goodsSno),
    queryFn: () => goodsService.getRelatedGoods(goodsSno),
    enabled,
  });
};
